import { useLocation, useNavigate } from "react-router-dom";
import { IUcApiResponse } from "../../shared/interfaces";
import { useCopyToClipboard } from "../../hooks/useCopyToClipboard";

export function useResultScreen() {
  const { copy } = useCopyToClipboard();
  const navigate = useNavigate();
  const {
    state: { response },
  } = useLocation() as {
    state: { response: IUcApiResponse };
  };

  const handleNewSearchBtn = () => {
    // Lógica para limpar os resultados
    navigate("/");
  };

  return {
    response,
    handleNewSearchBtn,
    copy,
  };
}
